import CSS from "./Title.module.scss";
type TitleProps = {
  children: React.ReactNode|React.ReactNode[],
  level?: 1|2
}
export function Title({children, level=1}: TitleProps) {
  return (
    <div className={`${CSS.container} ${CSS[`level_${level}`]}`}>{children}</div>
  )
}